module.exports = __webpack_public_path__ + "img/swal-error.082f4353.svg";